module.exports = __webpack_public_path__ + "images/9f9fcf1dbf1ab3309f4905e4600a88c6ebfc4d6a48843b66f88530f20c5464b2.svg";